import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class StandardQuestions extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'StandardQuestions'
  // Define default properties here
  static instanceDefaults () {
    return {
      isEnabled: true,
      userId: null,
      voteTypeId: null,
    }
  }
}
const servicePath = 'standard-questions'
const servicePlugin = makeServicePlugin({
  Model: StandardQuestions,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
